import React from 'react';

import { ContactCard } from '@src/components/promoCards/layouts/TwoThirds/contact';

const FooterContactCard = () => {
    return (
        <ContactCard
            id="home-page-contact-card"
            title="Contact"
            content="Need help with quoting or servicing? Have a question for your underwriter? Whatever your question, we can help you find the answer you need."
            link={{
                text: 'Contact Us',
                link: '/contact-us',
            }}
            imageSource="/img/guy-in-a-meeting.jpg"
        />
    );
};

export default FooterContactCard;
